<template>
  <BasePopup @close="closePopup">
    <div class="common-popup__container">
      <img
        :src="PopupPattern"
        alt="popup"
        class="common-popup__pattern"
      >
      <slot />
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import PopupPattern from '~/assets/images/patterns/popup.webp';

const emit = defineEmits<{
  close: [];
}>();

const closePopup = (): void => {
  emit('close');
};
</script>

<style lang="scss" scoped>
.common-popup {
  &__close {
    position: absolute;
    top: 1.2rem;
    right: 1.2rem;
    width: 2.4rem;
    height: 2.4rem;
    cursor: pointer;
  }

  &__container {
    position: relative;
    width: 44.5rem;
    padding: 3.2rem 2.4rem 2.4rem 2.4rem;
    border-radius: 2rem;
    color: $color-white;
    margin-left: 25rem;

    @include layout-aspect-mobile {
      margin-left: auto;
      margin-top: 10rem;
      width: 36rem;
    }
  }

  &__pattern {
    position: absolute;
    inset: 0;
    display: block;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: $z-underground;
    color: inherit;
  }
}
</style>
